// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

export const TENANT_SETTINGS_UPDATED_EVENT = "tenant-settings-updated";

/**
 * Broadcast that a tenant's settings changed so listeners can re-fetch and
 * apply updates (e.g. theme colors, language) without page reload.
 */
export const emitTenantSettingsUpdated = (tenantId) => {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent(TENANT_SETTINGS_UPDATED_EVENT, {
      detail: { tenantId: tenantId || null },
    }),
  );
};
